import I18n from 'i18n-js'

const RetailerSettingsBrandSettingsLocations: React.FC = () => {
  return <>{I18n.t('retailerSettings.brandSettings.locations.title')}</>
}

export default RetailerSettingsBrandSettingsLocations
